import posthog from 'posthog-js';

export default {
  install(Vue) {
    posthog.init('phc_fsS45MrcvEpu8Fcbt2cfIyzEBJxO1vgt7EOEDeftz9C', {
      api_host: 'https://us.i.posthog.com',
      capture_pageview: false,
    });

    Vue.prototype.$posthog = posthog;
  },
};
